import React from 'react'

import cn from '../../libs/class-names'

import closeIcon from '../../assets/icons/close.svg'

import Icon from '../icon'
import LinkButton from '../link-button'

export interface Props {
  classNames?: string[]
  filters: React.ReactNode
  filtersLabel: React.ReactNode
  searchBar?: React.ReactNode
  onClearAll?: React.MouseEventHandler
  clearAllLabel?: string
}

const FilterBar = ({
  classNames,
  filtersLabel,
  filters,
  searchBar,
  onClearAll,
  clearAllLabel,
}: Props) => (
  <div className={cn('FilterBar', {}, classNames)}>
    <div className="FilterBar__filters">
      <div className="FilterBar__label">{filtersLabel}</div>
      {filters}
      {onClearAll && clearAllLabel && (
        <LinkButton appearance="minor" icon={<Icon source={closeIcon} />} onClick={onClearAll}>
          {clearAllLabel}
        </LinkButton>
      )}
    </div>
    {!!searchBar && <div className="FilterBar__searchBar">{searchBar}</div>}
  </div>
)

export default FilterBar
